module.exports = __webpack_public_path__ + "static/media/bg_business_partner.b93bc073.webp";